// extracted by mini-css-extract-plugin
export var carrierTab = "_5k-0";
export var carrierTabActive = "_5k-1 _5k-0";
export var carrierTabInactive = "_5k-2 _5k-0";
export var carrierTabLabel = "_5k-3";
export var carrierTabLabelActive = "_5k-4 _5k-3";
export var carrierTabLabelInactive = "_5k-5 _5k-3";
export var carrierTabPercentage = "_5k-6";
export var carrierTabPercentageActive = "_5k-7 _5k-6";
export var carrierTabPercentageInactive = "_5k-8 _5k-6";
export var carrierTabWinnable = "_5k-9";
export var carrierTabWinnableActive = "_5k-a _5k-9";
export var carrierTabWinnableInactive = "_5k-b _5k-9";
export var comparisonContainer = "_5k-d";
export var missingRateButton = "_5k-n";
export var missingRateButtonActive = "_5k-o _5k-n";
export var missingRateButtonInactive = "_5k-p _5k-n";
export var missingRateButtonLabel = "_5k-q";
export var missingRateButtonLabelActive = "_5k-r _5k-q";
export var missingRateButtonLabelInactive = "_5k-s _5k-q";
export var sidebar = "_5k-c";
export var strategyButton = "_5k-e";
export var strategyButtonActive = "_5k-f _5k-e";
export var strategyButtonDescription = "_5k-k";
export var strategyButtonDescriptionActive = "_5k-l _5k-k";
export var strategyButtonDescriptionInactive = "_5k-m _5k-k";
export var strategyButtonInactive = "_5k-g _5k-e";
export var strategyButtonLabel = "_5k-h";
export var strategyButtonLabelActive = "_5k-i _5k-h";
export var strategyButtonLabelInactive = "_5k-j _5k-h";
export var unitToggleButton = "_5k-t";
export var unitToggleButtonActive = "_5k-u _5k-t";
export var unitToggleButtonInactive = "_5k-v _5k-t";
export var unitToggleButtonLabel = "_5k-w";
export var unitToggleButtonLabelActive = "_5k-x _5k-w";
export var unitToggleButtonLabelInactive = "_5k-y _5k-w";